"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[442],{

/***/ 2432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ TilesGrid; },
/* harmony export */   "W": function() { return /* binding */ TilesGridWrapper; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13102);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28165);



var TilesGridWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eazx9zv1"
} : 0)("position:relative;width:100%;max-width:900px;height:320px;margin:0 auto;padding:80px 0 80px;overflow:hidden;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("sm");
}, "{max-width:1200px;height:385px;}", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:1480px;}&::before,&::after{content:'';display:block;width:100%;height:100%;position:absolute;top:0;left:0;z-index:1;pointer-events:none;}&::before{", function (_ref3) {
  var gradientColor = _ref3.gradientColor;
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("background:linear-gradient(90deg, ", gradientColor, " 0%, ", (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .transparentize */ .DZ)(1, gradientColor), " 35%),linear-gradient(0, ", gradientColor, " 0%, ", (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .transparentize */ .DZ)(1, gradientColor), " 50%);" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
  );
}, ";}&::after{", function (_ref4) {
  var gradientColor = _ref4.gradientColor;
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("background:linear-gradient(-90deg, ", gradientColor, " 0%, ", (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .transparentize */ .DZ)(1, gradientColor), " 35%);" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
  );
}, ";}" + ( true ? "" : 0));
var TilesGrid = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eazx9zv0"
} : 0)("position:absolute;top:50%;left:50%;z-index:0;transform:translate(-50%, -50%);width:900px;", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("sm");
}, "{width:1200px;}", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.up("lg");
}, "{width:1480px;}" + ( true ? "" : 0));

/***/ }),

/***/ 20442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ LogoTiles; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/utils/useInView/index.ts + 1 modules
var useInView = __webpack_require__(85807);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/LogoTiles.views.tsx
var LogoTiles_views = __webpack_require__(2432);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/LogoTiles/LogoTiles.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var LogoGrid = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(5922), __webpack_require__.e(5838)]).then(__webpack_require__.bind(__webpack_require__, 75838));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(75838)];
    }
  }
});

var BaseLogoTiles = function BaseLogoTiles(_ref) {
  var tokens = _ref.tokens;
  var wrapperRef = (0,react.useRef)(null);
  var isInView = (0,useInView/* default */.Z)(wrapperRef, {
    options: {
      rootMargin: "200px"
    }
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles_views/* TilesGridWrapper */.W, _objectSpread(_objectSpread({}, tokens), {}, {
    ref: wrapperRef,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles_views/* TilesGrid */.$, {
      children: isInView && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoGrid, {})
    })
  }));
};

var LogoTiles = (0,useDesignTokens/* withDesignTokens */.Y)(BaseLogoTiles, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      gradientColor: theme.palette.neutrals.cloud[100]
    };
  },
  dark: function dark(theme) {
    return {
      gradientColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      gradientColor: theme.palette.twilio.gray[10]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/templates/LogoTiles/index.ts


/***/ })

}]);